<template>
  <!-- 作品 -->
  <div v-if="total > 0">
  <div class="cont-zuopin">
    <div class="clearfix" v-if="total > 0">
      <div
        class="work-card-one"
        v-for="(item, index) in productionData"
        :key="index"
        :title="item.productionName "
      >
        <router-link
          :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
          target="_blank"
          class="img-f"
        >
          <img :src="item.productionCover" alt="" />
        </router-link>
        <div class="card-infoes">
          <router-link
            :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
            target="_blank"
            :title="item.productionName"
            class="card-tit over-ellipsis"
            >{{ item.productionName }}</router-link
          >
          <div class="card-tags over-ellipsis">
            {{ item.tagStr }}
            <span
              class="tag-item"
              v-for="(item_bak, index_bak) in item.tags"
              :key="index_bak"
              >/{{ item_bak.tag }}
            </span>
          </div>
          <div class="card-czs">
            <i class="icon zan"></i
            ><span class="much">{{ item.likeCount }}</span>
            <i class="icon cai"></i
            ><span class="much">{{ item.dislikeCount }}</span>
            <i class="icon pinglun"></i
            ><span class="much">{{ item.commentCount }}</span>
            <i class="icon zhuanfa"></i
            ><span class="much">{{ item.shareCount }}</span>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="item.imgUrl" alt="" />
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">{{
            item.creatorName
          }}</router-link>
          <div class="date">{{ item.createTimeStr | formatTime }}</div>
        </div>
      </div>
    </div>

    <div class="pagintion-f">
      <el-pagination
        background
        @current-change="search"
        layout="prev, pager, next"
        :current-page="productionParam.pageIndex"
        :page-size="productionParam.pageSize"
        :total="total"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </div>

  </div>
  </div>
  <div class="common-no-data" v-else>
    <img class="img" :src="require('@/assets/images/empty_img.png')" alt="" />
    <span class="words">抱歉！您访问的页面暂无数据</span>
  </div>

</template>

<script type="text/ecmascript-6">
import productionApi from '@/api/production'
// import Pagination from '@/components/Pagination'
//import axios from 'axios';
import { mapState } from "vuex";
import updateTdk from "@/utils/tdk";
export default {
  components: {
    //Pagination
  },
  data () {
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      productionData:[],//列表数据
      total:0,
      userId:0,
      productionParam:{
        creatorId:0,
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 10,
        pageSizes:[10,20,30],
        productionType:'',//作品类型
        productionTags:'',//作品 标签
      },
    }
  },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },
  mounted() {
    this.isMounted = true;

    let userId=this.$route.query.userId;
    this.userId=userId;
    this.productionParam.creatorId = userId

    const alreadyIncremented = !!this.productionDetail;
    if (!alreadyIncremented) {
      this.fetchData().then(this.initData());
    } else {
      this.initData();
    }
  },
  methods:{
    fetchData(){
      return this.$store
              .dispatch("FETCH_USER_DETAIL", {
                id:this.$route.query.userId
              })
              .finally(() => {
                this.$loading(false);
                //console.log("this.userDetail =====  ",this.userDetail)
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initData(){
      this.search(1)
    },
    search(page){
      let this_ = this
      this_.productionParam.pageIndex = page
      productionApi.pageList(this_.productionParam).then(rePro => {
        this_.productionData = rePro.list
        this_.total = rePro.total
        this_.productionParam.pageIndex = rePro.pageNum
      })
    },
    setSeo(){
      this.headTitle = this.userDetail.userName+"的作品——人人动画网【官网】";
      this.headKeywords = this.userDetail.impressStr;
      this.headDesc =this.userDetail.userName+"的作品";
    },
    // setHead(){
    //   let url="/rrbi/userInfo/userInfo-one?userId="+this.userId+"&ti="+new Date().getMilliseconds();
    //   this.$axios.get(url).then(function(result){
    //     document.title =result.data.response.userName+"的作品——人人动画网【官网】"
    //     document.querySelector('meta[name="description"]').setAttribute('content', result.data.response.userName+"的作品")
    //   })
    //
    // },

  }
}
</script>

<style scoped lang="less">
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
//@import "../../../assets/less/stylePublic.less";
</style>
